import React, { useContext, useState } from 'react'
import { useEffect } from 'react';
import { cartContext } from './../../Context/CartContext';
import LoadingScreen from './../LoadingScreen/LoadingScreen';
import { Link } from 'react-router-dom';
import $ from 'jquery'
import { Helmet } from 'react-helmet';

export default function WishList() {

  const {removeFromWishList, getUserWishList, add, remove} = useContext(cartContext)
  const [wishContent, setwishContent] = useState(null)
  const [loading, setLoading] = useState(true)
  const [wishMsg, setwishMsg] = useState('')

  async function displayWishList() {
    let res = await getUserWishList()
    setwishContent(res?.data)
    setLoading(false)
  }

  async function removeProductFromWishList(id, index) {
    let response = await removeFromWishList(id)
    if (response !== false) {
      setwishMsg(response.message)
      setwishContent(response.data)
      
      $(`#wishRemoved${index}`).fadeIn(300, ()=> {
        setTimeout(() => {
          $(`#wishRemoved${index}`).fadeOut(300)
        }, 2000);
      })
      setLoading(true)
      await displayWishList()
      setLoading(false)
    }
  }

  async function addProduct(id, index) {
      let response = await add(id)
      if (response !== false) {
        console.log (response)
        $(`#add${index}`).fadeOut(200, ()=> {
          $(`#successMsg${index}`).fadeIn(200, ()=> {
            setTimeout(()=> {
              $(`#successMsg${index}`).fadeOut(200, ()=> {
                $(`#removing${index}`).fadeIn(200)
              })
            },2000)
          })
        })
      }
    
  }

  async function removeProduct(id, index) {
    let response = await remove(id)
    if (response !== false) {
      $(`#removing${index}`).fadeOut(200, ()=> {
        $(`#deleteMsg${index}`).fadeIn(200, ()=> {
          setTimeout(() => {
            $(`#deleteMsg${index}`).fadeOut(200, ()=> {
              $(`#add${index}`).fadeIn(200)
            })
          }, 2000);
        })
      } )
    }
  }


  useEffect(()=> {
    displayWishList()
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Your WishList</title>
      </Helmet>
      {loading ? (
        <LoadingScreen />
      ) : wishContent?.length > 0 ? (
        <div className="p-4 my-3">
          <div>
            <h2 className="text-main fw-bold">Wish List</h2>
          </div>
          <hr />
          <div className="row bg-transparent">
            {wishContent?.map((product, index) => (
              <div key={index} className="col-md-4 col-lg-3 col-xl-2">
                <div className="product px-2 py-3 h-100 position-relative ">
                  <img
                    src={product?.imageCover}
                    className="w-100"
                    alt={product?.title}
                  />
                  <Link to={`/productdetails/${product._id}`}>
                    <span className="look Btn rounded-3 w-75 m-auto">
                      Quick Look<i className="ms-2 fa-solid fa-expand"></i>
                    </span>
                  </Link>
                  <span className="text-main font-sm fw-bold">
                    {product?.category?.name}
                  </span>
                  <h3 className=" h6 fw-bolder">
                    {product?.title?.split(" ").slice(0, 2).join(" ")}
                  </h3>
                  <div className="d-flex justify-content-between">
                    <p>
                      {product?.priceAfterDiscount ? (
                        <>
                          <span className=" text-decoration-line-through text-muted moderate">
                            {product?.price}
                          </span>{" "}
                          <span className=" text-muted fw-bold">
                            {product?.priceAfterDiscount}EGP
                          </span>
                        </>
                      ) : (
                        <span className="text-muted fw-bold">
                          {product?.price}EGP
                        </span>
                      )}
                    </p>
                    <p>
                      <span className="moderate">
                        {product?.ratingsAverage}{" "}
                        <i className="fas fa-star rating-color moderate"></i>{" "}
                      </span>
                    </p>
                  </div>
                  <button
                    id={`add${index}`}
                    onClick={() => addProduct(product._id, index)}
                    className="btn Btn w-100 addBtn mb-1"
                  >
                    Add <i className="ms-2 fs-5 fa-solid fa-cart-plus"></i>
                  </button>
                  <button
                    id={`listRemove${index}`}
                    onClick={() =>
                      removeProductFromWishList(product._id, index)
                    }
                    className="btn btn-outline-danger w-100 addBtn"
                  >
                    Remove <i className="fa-solid fa-box ms-2"></i>
                  </button>
                  <div
                    id={`successMsg${index}`}
                    className="alert alert-success successMsg"
                    style={{ display: "none" }}
                  >
                    Product added successfully to your cart{" "}
                    <i className="me-2 fs-5 fa-regular fa-thumbs-up"></i>
                  </div>
                  <div
                    id={`wishRemoved${index}`}
                    className="alert alert-danger"
                    style={{ display: "none" }}
                  >
                    {wishMsg}
                  </div>
                  <div
                    id={`deleteMsg${index}`}
                    className="alert alert-danger deleteMsg"
                    style={{ display: "none" }}
                  >
                    Product Removed successfully from your cart
                  </div>
                  <div
                    id={`removing${index}`}
                    className="removing"
                    style={{ display: "none" }}
                  >
                    <button
                      id={`remove${index}`}
                      onClick={() => removeProduct(product._id, index)}
                      className="btn btn-outline-danger  w-100 mt-2"
                    >
                      Remove from Cart{" "}
                      <i className="ms-2 fs-5 fa-regular fa-trash-can"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-1">
          <img
            className=""
            src={require("../../assets/images/empty-wishlist1.png")}
            alt="empty-cart"
          />
          <div>
            <h2 className="h4">
              {" "}
              <Link
                className="hoveringClick fw-bold fa-fade text-main"
                style={{
                  "--fa-animation-duration": "2s",
                  "--fa-fade-opacity": 0.6,
                }}
                to="/"
              >
                Shopping Now
              </Link>
            </h2>
          </div>
        </div>
      )}
    </>
  );
}
